const useProxy = (hostlink) => (url) => (process.env.NODE_ENV === 'development' ? url : `${hostlink}${url}`);

export default useProxy;
